import React from 'react';
import styled from 'react-emotion';
import posed from 'react-pose';
import { Link } from '../CategoryPage/CategoryTree/CategoryTree';

const Wrapper = styled.li`
  border-bottom: 1px solid #ddd;
  padding: 6px 0;
  margin-left: 1rem;
`;
const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Link)`
  font-weight: bold;
  display: block;
  padding-left: 0;
  color: #444;
`;

const Carot = styled.span`
  display: block;
  position: relative;
  padding: 12px;
  cursor: pointer;
  margin-right: 10px;

  transform: rotate(${p => (p.open ? 180 : 0)}deg);
  transition: 0.2s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
    transform: translate(-50%, -50%);
    border-top: 5px solid #444;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
`;

const Dropdown = posed.ul({
  open: { height: 'auto' },
  closed: { height: '1px' }
});

const List = styled(Dropdown)`
  overflow: hidden;

  ${Link} {
    padding-top: 3px;
    padding-bottom: 3px;
    margin-bottom: 2px;
    font-size: 13px;
    color: #444;
  }
`;

function SlideDropdown({ category, isOpen, setOpen, open }) {
  const { id, hasSubcategories } = category;

  const toggle = () => setOpen(isOpen ? '' : id);

  const subcategoriesIds = hasSubcategories
    ? category.subcategories.map(c => c.id)
    : [];

  if (subcategoriesIds.includes(open)) {
    setOpen(id);
  }

  return (
    <Wrapper>
      <TitleRow>
        <Title category={category} />
        <Carot open={isOpen} onClick={toggle} />
      </TitleRow>
      {hasSubcategories && (
        <List pose={isOpen ? 'open' : 'closed'}>
          {category.subcategories.map(subcategory => (
            <Link key={subcategory.id} category={subcategory} />
          ))}
        </List>
      )}
    </Wrapper>
  );
}

export default SlideDropdown;
